import * as React from 'react'

import { cn } from '@/lib/utils'
import { Checkbox } from '~/client/src/shared/components/shadcn-ui/checkbox'

interface IProps {
  label?: string
  children?: React.ReactNode
  checked?: boolean
  indeterminate?: boolean
  onClick?: () => void
  disabled?: boolean
}

const OptionsCheckItem: React.FC<IProps> = ({
  label,
  children,
  checked,
  indeterminate,
  onClick,
  disabled,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (disabled || !onClick) return
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClick()
    }
  }

  return (
    <div
      role="option"
      aria-selected={checked || undefined}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : 0}
      onClick={disabled ? undefined : onClick}
      onKeyDown={handleKeyDown}
      className={cn(
        'tw:flex tw:w-full tw:items-center tw:gap-2 tw:rounded-md tw:pl-1.5 tw:pr-2 tw:py-1 tw:text-app-dense tw:outline-none tw:transition-colors tw:cursor-pointer',
        'tw:hover:bg-accent tw:hover:text-accent-foreground tw:focus-visible:bg-accent tw:focus-visible:text-accent-foreground',
        disabled && 'tw:opacity-50 tw:cursor-not-allowed',
      )}
    >
      <Checkbox checked={checked} indeterminate={indeterminate} displayOnly />
      <span className="tw:flex-1 tw:min-w-0">{children ?? label}</span>
    </div>
  )
}

export default OptionsCheckItem
